import Termin           from './module/termin';
import Kontaktdaten     from './module/kontaktdaten';
import Zusammenfassung  from './module/zusammenfassung';
import Danke            from './module/danke';

const moduleConfig = {
    "termin": {
        name: "RDV",
        title: "Sélections nomination",
        subtext: "S'il vous plaît sélectionnez votre date préférée",
        module: Termin,
        required: ["date", "timeslot"]
    },
    "kontaktdaten": {
        name: "Données",
        title: "Contact",
        subtext: "S'il vous plaît entrer vos informations de contact",
        module: Kontaktdaten
    },
    "zusammenfassung": {
        name: "Enquête",
        title: "vos entrées",
        subtext: "S'il vous plaît vérifier votre saisie",
        module: Zusammenfassung
    },
    "danke": {
        name: "Merci",
        title: "Nous vous remercions de votre réservation de rendez-vous",
        subtext: "Le médecin a été informé",
        module: Danke
    }
};
module.exports = moduleConfig;


// WEBPACK FOOTER //
// ./src/moduleConfig.js